import { AUTHENTICATION_TYPES_VALUES } from '../types/AuthenticationType';

const authenticationTypes = [...AUTHENTICATION_TYPES_VALUES] as string[];

const isAuthenticationTypeValid = (authenticationType: string) => {
  return authenticationTypes.indexOf(authenticationType) !== -1;
};

export default isAuthenticationTypeValid;
